import script from "./TumorBoardNewSession.vue?vue&type=script&setup=true&lang=js"
export * from "./TumorBoardNewSession.vue?vue&type=script&setup=true&lang=js"

import "./TumorBoardNewSession.vue?vue&type=style&index=0&id=503d7e19&scoped=true&lang=css"
import "./TumorBoardNewSession.vue?vue&type=style&index=1&id=503d7e19&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-503d7e19"]])

export default __exports__